// extracted by mini-css-extract-plugin
module.exports = {"time-range":"styles_time-range__du3YA","timeRange":"styles_time-range__du3YA"};